/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as msRest from "@azure/ms-rest-js";

export const gachaId0: msRest.OperationURLParameter = {
  parameterPath: "gachaId",
  mapper: {
    required: true,
    serializedName: "gachaId",
    type: {
      name: "String"
    }
  }
};
export const gachaId1: msRest.OperationQueryParameter = {
  parameterPath: [
    "options",
    "gachaId"
  ],
  mapper: {
    serializedName: "gachaId",
    type: {
      name: "String"
    }
  }
};
export const hasPlayed: msRest.OperationQueryParameter = {
  parameterPath: [
    "options",
    "hasPlayed"
  ],
  mapper: {
    serializedName: "hasPlayed",
    type: {
      name: "Boolean"
    }
  }
};
export const isSmsAuthedUser: msRest.OperationQueryParameter = {
  parameterPath: [
    "options",
    "isSmsAuthedUser"
  ],
  mapper: {
    serializedName: "isSmsAuthedUser",
    type: {
      name: "Boolean"
    }
  }
};
export const limit: msRest.OperationQueryParameter = {
  parameterPath: [
    "options",
    "limit"
  ],
  mapper: {
    serializedName: "limit",
    type: {
      name: "Number"
    }
  }
};
export const offset: msRest.OperationQueryParameter = {
  parameterPath: [
    "options",
    "offset"
  ],
  mapper: {
    serializedName: "offset",
    type: {
      name: "Number"
    }
  }
};
export const os: msRest.OperationQueryParameter = {
  parameterPath: [
    "options",
    "os"
  ],
  mapper: {
    serializedName: "os",
    type: {
      name: "String"
    }
  }
};
export const searchWord: msRest.OperationQueryParameter = {
  parameterPath: [
    "options",
    "searchWord"
  ],
  mapper: {
    serializedName: "search-word",
    type: {
      name: "String"
    }
  }
};
export const status: msRest.OperationQueryParameter = {
  parameterPath: [
    "options",
    "status"
  ],
  mapper: {
    serializedName: "status",
    type: {
      name: "String"
    }
  }
};
export const verificationID: msRest.OperationQueryParameter = {
  parameterPath: [
    "options",
    "verificationID"
  ],
  mapper: {
    serializedName: "verificationID",
    type: {
      name: "String"
    }
  }
};
export const winningId: msRest.OperationURLParameter = {
  parameterPath: "winningId",
  mapper: {
    required: true,
    serializedName: "winningId",
    type: {
      name: "String"
    }
  }
};
